function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { bool, func, number, object, string } from 'prop-types';
import clsx from 'clsx';
import Chip from '../internals/components/chip/Chip';

/**
 * Used in a group to allow a single selection, similar to a radio button
 */
const SovosChipChoice = _ref => {
  let {
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Chip, _extends({
    className: clsx('sovosChipChoice', className)
  }, rest));
};
SovosChipChoice.propTypes = {
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Content of the chip
   */
  label: string.isRequired,
  /**
   * Maximum width of the chip
   */
  maxWidth: number,
  /**
   * Callback fired when the chip is clicked
   */
  onClick: func,
  /**
   * If `true`, the chip is selected. This will change the background color
   */
  selected: bool
};
SovosChipChoice.baseComponent = {
  name: 'Chip',
  link: 'chip/'
};
export default SovosChipChoice;